import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, Link } from 'react-router-dom';
import {
  Breadcrumb,
  BackdropCircular,
  ImageGalleryDialog
} from 'components';
import {
  Card,
  Tabs,
  Tab,
  IconButton,
  Button,
  Icon,
  Dialog,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  getHomepageBannerGroupApi,
  addNewBannerSlideApi,
  getAssetManagerCategoryTagsApi
} from 'api';
import { assetManagerUrl } from 'configs';
import BannerSlidesList from './bannerSlidesList';
import UploadBannerSlide from './uploadBannerSlide';


const useStyles = makeStyles(() => ({
  modalTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row'
  },
  cancelButton: {
    padding: '12px 20px'
  }
}));

const HomepageBanner = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    homepageBannerGroup,
    loadingHomepageBannerGroups,
    homepageSlidesActive,
    homepageSlidesDraft,
    loadingSaveSlide,
    loadingDeleteSlide,
    loadingAddNewSlide
  } = useSelector((state) => state.banner_manager);
  const {profile: {stores = []}, loadingProfile} = useSelector((state) => state.user);
  const {
    assetCategoryTags,
    loadingAssetCategoryTags
  } = useSelector((state) => state.asset_manager);

  const loading =
    loadingHomepageBannerGroups ||
    loadingProfile ||
    loadingSaveSlide ||
    loadingDeleteSlide ||
    loadingAddNewSlide ||
    loadingAssetCategoryTags;
  const storeCode = stores.length && stores[0]?.storeCode;
  const tagId = assetCategoryTags.find((tag) => tag.tagCode === 'welcome_banner')?.id;

  const [tabValue, setTabValue] = useState(location.hash);
  const [openUploadSlideDialog, setOpenUploadSlideDialog] = useState(false);
  const [openImageGallery, setOpenImageGallery] = useState(false);

  useEffect(() => {
    if (!homepageBannerGroup.length && storeCode) {
      getHomepageBannerGroupApi({dispatch, identifier: storeCode});
    }
  }, [storeCode]);

  useEffect(() => {
    getAssetManagerCategoryTagsApi({dispatch, categoryName: 'Storebuild-automaton'});
  }, []);

  const handleChangeTab = (event, newValue) => setTabValue(newValue);

  const addNewBanner = (slide) => {
    const slideData = {
      image: slide.filename,
      is_active: false,
      title: `${homepageBannerGroup.title} Slide ${(homepageBannerGroup.slides?.length + 1)}`,
      hosted_image: '1',
      hosted_image_thumburl: `${assetManagerUrl}/${slide.webPath}`,
      hosted_image_url: `${assetManagerUrl}/${slide.webPath}`,
      url: '',
      alt_text: `${homepageBannerGroup.title} Slide ${(homepageBannerGroup.slides?.length + 1)}`,
      slide_startdate: null,
      slide_enddate: null,
      slide_sort_order: (homepageBannerGroup.slides.length + 1),
      url_target: '_self',
      group_id: [
        `${homepageBannerGroup.group_id}`
      ]
    };

    addNewBannerSlideApi({dispatch, slideData});
  };

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'UI Configurations', path: '/settings#UI_configurations' },
            { name: 'Homepage Settings', path: '/configurations/homepage'},
            { name: 'Homepage Banner' }
          ]}
        />
      </div>
      <div className="flex px-8 pt-0 pb-4 justify-end">
        <Button
          type="button"
          color="primary"
          variant="outlined"
          className="mr-4"
          onClick={() => setOpenUploadSlideDialog(true)}
        >
          <Icon className="mr-2">
            upload
          </Icon>
          Upload Banner
        </Button>
        <Button
          type="button"
          color="primary"
          variant="contained"
          className="mr-4"
          onClick={() => setOpenImageGallery(true)}
        >
          Search from Library
        </Button>
      </div>
      <Card elevation={25} className="px-8 pb-8 pt-4 mx-10 mb-25">
        <Tabs
          value={tabValue == '' ? '#active' : tabValue}
          onChange={handleChangeTab}
          textColor="primary"
          indicatorColor="primary"
          aria-label="secondary tabs"
          className="mb-8"
        >
          <Tab
            label={<div className="flex items-center">Active ({homepageSlidesActive.length})</div>}
            value="#active"
            component={Link}
            className="capitalize font-bold flex items-center px-4"
            to="/homepage-banner#active"
          />
          <Tab
            label={<div className="flex items-center">Draft ({homepageSlidesDraft.length})</div>}
            value="#draft"
            component={Link}
            className="capitalize font-bold flex items-center px-4"
            to="/homepage-banner#draft"
          />
        </Tabs>
        {(tabValue === '#active' || tabValue === '') && <BannerSlidesList data={homepageSlidesActive} type="active" />}
        {tabValue === '#draft' && <BannerSlidesList data={homepageSlidesDraft} type="draft" />}
      </Card>
      <Dialog
        open={openUploadSlideDialog}
        onClose={() => setOpenUploadSlideDialog(false)}
        aria-label="upload-banner-slide"
        fullWidth
        maxWidth="md"
      >
        <div className={classes.modalTitleContainer}>
          <DialogTitle className="text-16 font-semibold text-dark-gray">Upload Banner</DialogTitle>
          <IconButton
            className={classes.cancelButton}
            title="Cancel"
            color="primary"
            variant="contained"
            onClick={() => {
              setOpenUploadSlideDialog(false);
            }}
          >
            <Icon className="text-gray">cancel</Icon>
          </IconButton>
        </div>
        <DialogContent>
          <UploadBannerSlide isOpen={setOpenUploadSlideDialog} />
        </DialogContent>
      </Dialog>
      {tagId &&
        <ImageGalleryDialog
          title="Banner Library"
          open={openImageGallery}
          setOpen={setOpenImageGallery}
          onImageSelect={addNewBanner}
          cols={3}
          rowHeight={90}
          imageTagId={tagId}
          selectButtonTitle="Select this banner"
        />
      }
      <BackdropCircular loading={loading} />
    </div>
  );
};

export default HomepageBanner;
